module.exports = __webpack_public_path__ + "static/media/career-hero-poster-mobile.13370729.jpg";